export enum FeatureEntitlements {
  InsightsBenchmarkMetricsEntitlement = 'insights_benchmark_metrics',
  AdsSurfaceFilterEntitlement = 'ads_surface_filter',
  PartnerBulkDeliveryEnabled = 'fulfillment.delivery_software.partner_bulk_delivery_enabled',
}
